module.exports = __webpack_public_path__ + "daicolo_logo.png?eede510e81a3228e13fba6719c01303e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daicolo_logo.png
// module id = 559
// module chunks = 0